import { RadioChangeEvent } from 'antd';
import { useEffect, useState } from 'react';

import * as St from './SortOptions.styles';

import { SortBy } from '~/core/enums';
import { useTrendingLabels } from '~/core/hooks/useTrendingLabels';
import i18n from '~/core/i18n/i18n';
import {
  AvailableSortComponents,
  TypeOfFilter,
} from '~/core/types/sortAndFilter';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { selectSortBy, updateSortBy } from '~/redux/slices/sortAndFilter';
import CommonRadio from '~atoms/CommonRadio';

type SortOptionLabels = {
  [key: string]: string;
};

type SortOptionsProps = {
  component: AvailableSortComponents;
  filters?: TypeOfFilter[];
};

const SortOptions = ({ component, filters }: SortOptionsProps) => {
  const dispatch = useAppDispatch();
  const { getTrendingNowLabel } = useTrendingLabels(filters);
  const [trendingNowLabel, setTrendingNowLabel] = useState<string>(
    i18n.t('SCROLLABLE_AREA.COLOR.TRENDING_NOW')
  );

  const sortBy = useAppSelector(selectSortBy(component));

  useEffect(() => {
    const fetchTrendingNowLabel = async () => {
      const label = await getTrendingNowLabel();

      setTrendingNowLabel(label);
    };

    fetchTrendingNowLabel();
  }, [filters, getTrendingNowLabel]);

  const sortOptionsLabels: SortOptionLabels = {
    [SortBy.TrendingNow]: trendingNowLabel,
    [SortBy.LowToHigh]: i18n.t(SortBy.LowToHigh),
    [SortBy.HighToLow]: i18n.t(SortBy.HighToLow),
    [SortBy.NameAZ]: i18n.t(SortBy.NameAZ),
    [SortBy.NameZA]: i18n.t(SortBy.NameZA),
  };

  const handleChange = (event: RadioChangeEvent) => {
    dispatch(updateSortBy({ component, sortBy: event.target.value }));
  };

  return (
    <CommonRadio onChange={handleChange} value={sortBy}>
      {Object.entries(sortOptionsLabels).map(([key, label]) => (
        <St.Radio key={key} value={key}>
          {label}
        </St.Radio>
      ))}
    </CommonRadio>
  );
};

export default SortOptions;
